module.exports = __webpack_public_path__ + "img/diagnostics.5937c1bb.png";